import React from 'react';
import {Chip} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import HelperUtils from '@shared/utils/HelperUtils';

type ArrivalChipProps = {
  canonicalStatus?: string | null;
  arrivedAt?: string | null;
};

const ArrivalChip: React.FC<ArrivalChipProps> = ({
  canonicalStatus,
  arrivedAt
}) => {
  const {t} = useTranslation();

  if (canonicalStatus !== 'arrived' || !arrivedAt) {
    return null;
  }

  const formattedTime = HelperUtils.formatDisplayTime(arrivedAt);

  return (
    <Chip
      size="small"
      color="primary"
      label={t('EMR_SYNC.ARRIVAL_CHIP', {time: formattedTime})}
    />
  );
};

export default ArrivalChip;
